import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import {ResourcePlanerService} from "./services/resource-planer.service";
import {IEvent, ISchedulerItem} from "./models/scheduler";
import { IPagedResults } from '../core/models/base';

@Injectable({
  providedIn: 'root'
})
export class SchedulerResolver  {
  constructor(private schedulerService: ResourcePlanerService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ISchedulerItem[]> {
    return this.schedulerService.listEvents({
      pageNumber: 0,
      pageSize: 999999,
      start: new Date(new Date().setUTCHours(0,0,0,0)),
      end: new Date(new Date().setUTCHours(23,59,59,999))
    })
    .pipe(
      map(pagedResult => pagedResult.data)
    );
  }
}
